import { couplingACSPatterns } from '..';
import { couplingValues } from '../constants/couplingValues';
export function selectACSPattern(pattern) {
    const multiplicity = couplingValues[pattern];
    if (!multiplicity) {
        throw new Error(`multiplicity pattern ${pattern} is not supported`);
    }
    return couplingACSPatterns[multiplicity];
}
//# sourceMappingURL=selectACSPattern.js.map